import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthorizationService } from '../services';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private authorizationService: AuthorizationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handleAccessToken(req, next));
  }

  async handleAccessToken(req: HttpRequest<any>, next: HttpHandler) {
    const baseUrl = this.getBaseUrl(req.url);
    let audience = '';

    if (baseUrl === this.getBaseUrl(environment.masterDataApiRoot.url)) {
      audience = environment.masterDataApiRoot.audience;
    }

    var accessToken = '';

    if (this.authorizationService.HealthcareTopBar) {
      accessToken =
        await this.authorizationService.HealthcareTopBar.getAccessToken(
          audience
        );
    }

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return next.handle(req).toPromise();
  }

  private getBaseUrl(url: string): string {
    const urlObj = new URL(url);
    const baseUrl = `${urlObj.protocol}//${urlObj.host}`;

    return baseUrl;
  }
}
